import { useRouter } from 'helpers/navigation'
import { useDropTypeFromPath } from 'pages/Drops/useDropTypeFromPath'
import React, { FC } from 'react'
import { DROPS_BASE_PATH, DROPS_LIVE_SHOWS_OVERVIEW_PATH } from 'routes'
import { DropDetailsBackButtonLink } from 'uiComponents/atoms/Drops/DropDetailsBackButtonLink'

export const DropDetailsBackButton: FC<{ isLiveShow: boolean }> = ({
  isLiveShow,
}) => {
  const dropType = useDropTypeFromPath()
  const { navigateClient } = useRouter()

  const overviewPageRoute = isLiveShow
    ? DROPS_LIVE_SHOWS_OVERVIEW_PATH
    : `${DROPS_BASE_PATH}/${dropType}/overview`

  return (
    <DropDetailsBackButtonLink
      to={overviewPageRoute}
      onClick={navigateClient(overviewPageRoute)}
    />
  )
}
